import React from 'react';

const InlineErrorBanner = ({ message, fieldId, onDismiss }) => {
  if (!message) return null;

  return (
    <div className="inline-error-banner flex items-center justify-between py-3 px-4 rounded-lg my-4" role="alert" data-field-id={fieldId}>
      <div className="error-content flex items-center gap-3 flex-1">
        <svg className="error-icon shrink-0" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            fill="currentColor"
          />
        </svg>
        <span className="error-message text-sm font-medium">{message}</span>
      </div>
      {onDismiss && (
        <button
          type="button"
          className="error-dismiss bg-transparent border-0 text-xl cursor-pointer p-0 w-6 h-6 flex items-center justify-center leading-none"
          onClick={onDismiss}
          aria-label="Dismiss error"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default InlineErrorBanner;
